import React from "react";
import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="site-footer">
    <div className="container site-footer-inner">
      <div className="site-footer-grid">

        {/* ── Marque ── */}
        <div className="site-footer-brand">
          <div>
            <p className="site-footer-brand-name">Deenzine</p>
            <div className="site-footer-thread" aria-hidden="true" />
          </div>
          <p className="site-footer-tagline">
            Sacs en crochet faits main — pièces uniques, séries limitées, expédition soignée.
          </p>
          <div className="site-footer-socials">
            <a
              className="site-footer-social-link"
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>
            <a
              className="site-footer-social-link"
              href="https://tiktok.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              TikTok
            </a>
            <a
              className="site-footer-social-link"
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook
            </a>
          </div>
        </div>

        {/* ── Navigation ── */}
        <div>
          <p className="site-footer-col-title">Navigation</p>
          <nav className="site-footer-links">
            <Link className="site-footer-link" to="/">Accueil</Link>
            <Link className="site-footer-link" to="/products">Collection</Link>
            <Link className="site-footer-link" to="/destockage">Déstockage</Link>
            <Link className="site-footer-link" to="/contact">Contact</Link>
          </nav>
        </div>

        {/* ── Informations légales ── */}
        <div>
          <p className="site-footer-col-title">Informations</p>
          <nav className="site-footer-links">
            <Link className="site-footer-link" to="/cgv">CGV</Link>
            <Link className="site-footer-link" to="/mentions-legales">Mentions légales</Link>
            <Link className="site-footer-link" to="/confidentialite">Confidentialité</Link>
          </nav>
        </div>

        {/* ── Contact ── */}
        <div>
          <p className="site-footer-col-title">Contact</p>
          <p className="site-footer-contact-label">Email</p>
          <a
            className="site-footer-contact-value site-footer-link"
            href="mailto:une.developpeuse01@gmail.com"
          >
            une.developpeuse01@gmail.com
          </a>
        </div>

      </div>

      {/* ── Bas de page ── */}
      <div className="site-footer-bottom">
        <span className="site-footer-copy">
          © {new Date().getFullYear()} Deenzine — Tous droits réservés
        </span>
        <div className="site-footer-bottom-links">
          <Link className="site-footer-bottom-link" to="/mentions-legales">Mentions légales</Link>
          <Link className="site-footer-bottom-link" to="/confidentialite">Confidentialité</Link>
          <Link className="site-footer-bottom-link" to="/cgv">CGV</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;